export type TncContentList = {
  title: string
  list?: TncContentList
}[]
export type TncContent = {
  title?: string
  slug?: string
  description?: string[]
  list?: TncContentList
}

export const TncContents: TncContent[] = [
  {
    description: [
      'Sebelum memutuskan melakukan transaksi pembelian bahan bangunan melalui Platform Buka Bangunan, Pengguna wajib terlebih dahulu mempelajari Syarat dan Ketentuan Buka Bangunan.',
      'Syarat dan Ketentuan Buka Bangunan ini merupakan bagian dari Aturan Penggunaan Buka Mitra Indonesia. Penggunaan Buka Bangunan tunduk pada Aturan Penggunaan Buka Mitra Indonesia, Kebijakan Privasi Buka Mitra Indonesia, dan Syarat dan Ketentuan Buka Bangunan sebagaimana tertulis di bawah ini.',
      'Dengan menggunakan aplikasi Buka Bangunan, melakukan transaksi bahan bangunan di Platform Buka Bangunan, maka Pengguna dianggap telah membaca, mengerti, memahami, dan menyetujui semua ketentuan dalam Aturan Penggunaan Buka Mitra Indonesia, Kebijakan Privasi Buka Mitra Indonesia dan Syarat dan Ketentuan Buka Bangunan ini serta segala perubahannya di kemudian hari.',
      'SYARAT DAN KETENTUAN INI ADALAH BENTUK KESEPAKATAN PENGGUNA DAN MERUPAKAN SEBUAH PERJANJIAN YANG SAH DAN MENGIKAT ANTARA PENGGUNA DAN BUKA MITRA INDONESIA. JIKA PENGGUNA TIDAK MENYETUJUI SALAH SATU, SEBAGIAN, ATAU SELURUH ISI SYARAT DAN KETENTUAN INI, MAKA PENGGUNA TIDAK DIPERKENANKAN MENGGUNAKAN ATAU MELANJUTKAN PROSES TRANSAKSI BUKA BANGUNAN.',
    ],
  },
  {
    title: 'DEFINISI',
    slug: 'definisi',
    description: [
      'Istilah-istilah dalam Aturan Penggunaan Buka Mitra Indonesia berlaku sepanjang tidak ditentukan lain dalam Syarat dan Ketentuan Buka Bangunan ini. Istilah-istilah di bawah ini mempunyai arti sebagai berikut:',
    ],
    list: [
      {
        title:
          '<b>Buka Bangunan</b> adalah salah satu fitur atau fasilitas yang disediakan oleh PT Buka Mitra Indonesia kepada Pengguna.',
      },
      {
        title:
          '<b>Platform Buka Bangunan</b> adalah aplikasi resmi berbasis Android yang dapat diakses oleh Pengguna untuk melakukan jual-beli produk bahan bangunan (https://bukabangunan.com/) yang dikelola oleh PT Buka Mitra Indonesia.',
      },
      {
        title:
          '<b>Pengguna</b> adalah pihak yang dapat mengakses Platform Buka Bangunan termasuk namun tidak terbatas pada Pembeli, Penyedia Produk, user offline, yang mana wajib mematuhi Syarat dan Ketentuan.',
      },
      {
        title:
          '<b>Penyedia Produk</b> adalah perusahaan maupun perorangan yang bekerjasama dengan Buka Mitra Indonesia untuk melakukan penjualan dan/atau penawaran Produk Bahan Bangunan kepada Pengguna melalui Platform Buka Bangunan serta wajib mematuhi Syarat dan Ketentuan.',
      },
      {
        title:
          '<b>Pembeli</b> adalah Pengguna terdaftar yang melakukan permintaan atas Barang yang dijual oleh Penyedia Produk di Platform Buka Bangunan.',
      },
      {
        title:
          '<b>Pembeli</b> adalah Pengguna terdaftar yang melakukan permintaan atas Barang yang dijual oleh Penyedia Produk di Platform Buka Bangunan.',
      },
      {
        title:
          '<b>Barang</b> atau <b>Produk Bahan Bangunan</b> adalah benda yang berwujud / memiliki fisik yang dapat diantar, yang dalam hal ini adalah seluruh produk Bahan Bangunan.',
      },
      {
        title:
          '<b>Syarat dan Ketentuan</b> adalah Syarat dan Ketentuan Buka Bangunan ini yang merupakan satu kesatuan dengan Aturan Penggunaan Buka Mitra Indonesia dan Kebijakan Privasi Buka Mitra Indonesia. ',
      },
    ],
  },
  {
    title: 'PERNYATAAN KEBENARAN DAN TANGGUNG JAWAB',
    slug: 'pernyataan-kebenaran-dan-tanggung-jawab',
    description: [
      'Dengan melanjutkan transaksi pembelian bahan bangunan melalui Platform Buka Bangunan, Pengguna menyatakan bahwa semua informasi dan semua dokumen yang Pengguna lampirkan dalam transaksi pembelian bahan bangunan melalui Platform Buka Bangunan adalah benar dan tepat. Pengguna akan bertanggung jawab penuh apabila di kemudian hari terjadi sesuatu hal sehubungan dengan ketidakbenaran data yang Pengguna berikan.',
    ],
  },
  {
    title: 'AKUN DAN KEAMANAN',
    slug: 'akun-dan-keamanan',
    list: [
      {
        title:
          'Pengguna wajib melakukan pendaftaran akun Buka Bangunan melalui aplikasi Buka Bangunan yang di download melalui Google Play store.',
      },
      { title: 'Buka Bangunan tidak memungut biaya pendaftaran kepada Pengguna.' },
      {
        title:
          'Pengguna memahami bahwa 1 (satu) nomor telepon hanya dapat digunakan untuk mendaftar 1 (satu) akun di Platform Buka Bangunan.  ',
      },
      {
        title: 'Pengguna yang telah mendaftar berhak bertindak sebagai:',
        list: [
          {
            title: 'Pembeli; dan/atau',
          },
          {
            title: 'Penyedia Produk.',
          },
        ],
      },
      {
        title:
          'Pendaftaran Akun Buka Bangunan untuk Pengguna Pembeli dilakukan melalui Platform Buka Bangunan dengan melengkapi data antara lain nomor telepon, KTP, <i>selfie</i> KTP, geolokasi dan data lain yang diminta Buka Bangunan.',
      },
      {
        title:
          'Pengguna wajib memberikan informasi identitas diri secara benar, akurat, terbaru dan lengkap berdasarkan pendaftaran yang tersedia pada Platform Buka Bangunan, dan terus memperbaruinya secara benar. Jika pengguna memberikan informasi yang tidak benar, tidak akurat, tidak mutakhir, dan tidak lengkap, Buka Bangunan berhak untuk menangguhkan, memblokir atau mengakhiri Akun Pengguna dan menolak setiap dan semua yang sedang atau akan digunakan pada Platform Buka Bangunan, atau bagian daripadanya.',
      },
      {
        title:
          'Pengguna yang akan bertindak sebagai Penyedia Produk akan langsung dihubungi oleh pihak internal Buka Bangunan. Pengguna berhak melakukan pengaturan terhadap item-item yang akan diperdagangkan beserta harga, minimum pembelian, konten foto, deskripsi barang dan sebagainya.',
      },
      {
        title:
          'Buka Bangunan tanpa pemberitahuan terlebih dahulu kepada Pengguna, memiliki kewenangan untuk melakukan tindakan yang perlu atas setiap dugaan pelanggaran atau pelanggaran Syarat dan Ketentuan dan/atau hukum yang berlaku, yakni tindakan berupa penghapusan Barang, pembatalan listing, suspensi Akun, dan/atau penghapusan Akun Pengguna.',
      },
      {
        title:
          'Buka Bangunan memiliki kewenangan untuk memberhentikan Akun Penyedia Produk baik sementara maupun permanen apabila didapati adanya tindakan kecurangan dalam bertransaksi dan/atau pelanggaran terhadap Syarat dan Ketentuan. Pengguna menyetujui bahwa Buka Bangunan berhak melakukan tindakan lain yang diperlukan terkait hal tersebut, termasuk namun tidak terbatas pada menolak pengajuan listing yang baru apabila ditemukan kesamaan data.',
      },
      {
        title:
          'Pengguna bertanggung jawab secara pribadi untuk menjaga kerahasiaan dan keamanan Akun, <i>one time password</i> (OTP) dan fasilitas keamanan lainnya untuk semua aktivitas yang terjadi dalam Akun Pengguna.',
      },
      {
        title:
          'Pengguna wajib segera memberitahu Buka Bangunan jika ada penggunaan yang tidak sah/valid dengan pengatasnamaan nama Akun Pengguna dan harus selalu pastikan bahwa Pengguna keluar (<i>log out</i>) dari Akun pada setiap akhir dari aktivitas pada Platform Buka Bangunan untuk mencegah penyalahgunaan pada Akun Pengguna.',
      },
      {
        title:
          'Pengguna memahami dan menyetujui bahwa untuk mempergunakan fasilitas keamanan <i>one time password</i> (OTP) maka penyedia jasa telekomunikasi terkait dapat sewaktu-waktu mengenakan biaya kepada Pengguna.',
      },
    ],
  },
  {
    title: 'TRANSAKSI PEMBELIAN',
    slug: 'transaksi-pembelian',
    list: [
      {
        title:
          'Pembeli wajib bertransaksi melalui prosedur transaksi yang telah ditetapkan oleh Buka Bangunan. Pembeli melakukan pembayaran dengan menggunakan metode pembayaran yang sebelumnya telah dipilih oleh Pembeli, dan kemudian Buka Bangunan akan meneruskan dana ke Penyedia Produk apabila tahapan transaksi jual beli pada aplikasi Buka Bangunan telah selesai.',
      },
      {
        title: 'Saat melakukan pembelian Barang, Pembeli menyetujui bahwa:',
        list: [
          {
            title:
              'Pembeli bertanggung jawab untuk membaca, memahami, dan menyetujui informasi/deskripsi keseluruhan Barang (termasuk didalamnya namun tidak terbatas pada kualitas, fungsi, ukuran, dan lainnya) sebelum membuat tawaran atau komitmen untuk membeli.',
          },
          {
            title:
              'Pembeli mengakui bahwa warna sebenarnya dari produk sebagaimana terlihat di Platform Buka Bangunan tergantung pada monitor komputer dan layar handphone Pembeli. Buka Bangunan telah melakukan upaya terbaik untuk memastikan warna dalam foto-foto yang ditampilkan pada Platform Buka Bangunan muncul seakurat mungkin, tetapi tidak dapat menjamin bahwa penampilan warna pada Platform Buka Bangunan akan akurat.',
          },
          {
            title:
              'Pembeli telah terikat secara hukum dengan Penyedia Produk untuk melakukan pembelian Barang dari Penyedia Produk.',
          },
          {
            title:
              'Pembeli menyadari dan menyepakati Buka Bangunan atau BMI tidak berperan sebagai penjual Barang, melainkan sebagai media perantara bagi Penyedia Produk dan Pembeli untuk melakukan transaksi melalui Platform Buka Bangunan oleh karenanya merupakan tanggung jawab sepenuhnya antara Penyedia Produk dan Pembeli. ',
          },
        ],
      },
      {
        title:
          'Pembeli memahami dan menyetujui bahwa ketersediaan stok Barang merupakan tanggung jawab Penyedia Produk yang menawarkan Barang tersebut. Terkait ketersediaan stok Barang dapat berubah sewaktu-waktu, sehingga dalam keadaan stok Barang kosong, maka Penyedia Produk akan menolak order.',
      },
      {
        title:
          'Pembeli memahami sepenuhnya dan menyetujui bahwa segala transaksi yang dilakukan antara Pembeli dan Penyedia Produk selain melalui Platform Buka Bangunan adalah merupakan tanggung jawab pribadi dari Pembeli.',
      },
      {
        title:
          'Buka Bangunan memiliki kewenangan sepenuhnya untuk menolak transaksi tanpa pemberitahuan terlebih dahulu.',
      },
      {
        title:
          'Pembeli menyetujui dan memahami bahwa dengan menggunakan Platform Buka Bangunan pada saat Pembeli melakukan transaksi pembelian, Buka Bangunan akan meneruskan data informasi Pembeli kepada Penyedia Produk atau pihak ketiga lainnya yang bekerjasama dengan Buka Bangunan.',
      },
      { title: 'Pembeli wajib memilih waktu pengiriman di halaman atur pesanan pada Platform Buka Bangunan.' },
      {
        title:
          'Pembeli wajib melakukan cek kelengkapan pada saat Barang telah diterima di Platform Buka Bangunan dan sebelum kurir Penyedia Bangunan melakukan bongkar muat Barang atau Barang diserah-terimakan oleh kurir Penyedia Bangunan kepada Pembeli. Buka Bangunan memberikan batas waktu 1x24 jam setelah pengiriman berstatus "dikirim" pada Platform Buka Bangunan, untuk Pembeli melakukan konfirmasi penerimaan Barang. Jika dalam batas waktu tersebut tidak ada konfirmasi atau klaim dari Pembeli, maka dengan demikian Pembeli menyatakan bahwa Barang telah diterima secara lengkap secara otomatis dan Pembeli perlu melakukan pembayaran penuh. Dalam hal Pembeli menyalahgunakan status konfirmasi penerimaan Barang maka Buka Bangunan berhak menangguhkan, memblokir atau mengakhiri Akun Pembeli. ',
      },
      {
        title:
          'Untuk metode pembayaran, Buka Bangunan menjalin kerja sama dengan sejumlah penyedia jasa perbankan/pembayaran yang terpercaya. Buka Bangunan berhak sewaktu-waktu untuk mengubah atau menghentikan, untuk sementara waktu atau seterusnya, atas suatu metode pembayaran tanpa pemberitahuan kepada Pengguna.',
      },
      {
        title:
          'Pengguna dapat membayar pesanan menggunakan salah satu metode pembayaran yang sudah Buka Bangunan sediakan. Pengguna berhak menentukan salah satu metode yang Pengguna anggap nyaman dan mudah. Metode pembayaran dapat dikenakan persyaratan tambahan sebagaimana Buka Bangunan tentukan dari waktu ke waktu. Buka Bangunan tidak bertanggung jawab apabila Pengguna melakukan pembayaran atau pengembalian diluar metode pembayaran yang telah disediakan Buka Bangunan.',
      },
      {
        title:
          'Jika Pembeli memilih metode pembayaran Bayar Setelah Terima Barang, Pembeli wajib melakukan pembayaran dengan Virtual Account sesuai dengan nominal yang sesuai dengan jumlah tagihan yang tertera pada halaman pembayaran. Buka Bangunan tidak bertanggung jawab atas kerugian yang dialami Pembeli, apabila Pembeli melakukan pembayaran yang tidak sesuai dengan jumlah tagihan yang tertera pada halaman pembayaran. Pembayaran oleh Pembeli wajib dilakukan segera (selambat-lambatnya dalam batas waktu 1x24 jam) setelah Pembeli mengkonfirmasi atas kelengkapan Barang yang diterima. Jika dalam batas waktu tersebut pembayaran belum dilakukan oleh Pembeli, pihak Buka Bangunan akan menghubungi Pembeli via Whatsapp. Jika pembayaran tetap tidak dilakukan maka pihak Buka Bangunan berhak melakukan kunjungan langsung ke lokasi Pembeli untuk penagihan.  ',
      },
      {
        title:
          'Jika Pembeli memilih metode pembayaran Promo Bayar 30 Hari, Pembeli wajib untuk melakukan registrasi tambahan sesuai dengan syarat dan ketentuan terkait Promo Bayar 30 Hari. Pembeli wajib menunggu 1x24 jam untuk mengetahui status persetujuan yang dikeluarkan oleh tim Buka Bangunan ',
      },
      {
        title:
          'Apabila Pembeli belum juga melakukan pembayaran maka Pembeli wajib mengembalikan Barang ke alamat yang ditentukan Buka Bangunan dan/atau memberikan wewenang dan hak kepada Buka Bangunan untuk melakukan penarikan Barang. Pembeli bertanggung jawab penuh atas kondisi, kelengkapan, jumlah dan kualitas Barang yang dikembalikan/ditarik dan menanggung biaya-biaya terkait pengembalian/penarikan Barang.',
      },
      {
        title:
          'Buka Bangunan berwenang untuk melakukan tindakan-tindakan yang diperlukan apabila diketahui terdapat transaksi pembelian menggunakan metode <i>split payment</i> atau penyalahgunaan lainnya, tindakan-tindakan tersebut antara lain pembatalan transaksi, pembatalan promo, cashback, penangguhan Akun atau lainnya yang ditentukan Buka Bangunan untuk melindungi kepentingan Pengguna.',
      },
      {
        title:
          'Pembeli menyetujui untuk tidak memberitahukan atau menyerahkan bukti pembayaran dan/atau data pembayaran kepada pihak lain selain Buka Bangunan. Dalam hal terjadi kerugian akibat pemberitahuan atau penyerahan bukti pembayaran dan/atau data pembayaran oleh Pembeli kepada pihak lain, maka hal tersebut akan menjadi tanggung jawab Pembeli.',
      },
      {
        title:
          'Setiap pungutan resmi atau pajak yang timbul terkait transaksi Buka Bangunan baik pembelian, pembayaran atau lainnya akan ditanggung oleh Pembeli sesuai peraturan yang berlaku.',
      },
      {
        title:
          'Pembeli memahami dan menyetujui bahwa setiap klaim yang dilayangkan setelah adanya konfirmasi / konfirmasi otomatis atas cek kelengkapan Barang adalah bukan menjadi tanggung jawab Buka Bangunan. Kerugian yang timbul setelah adanya konfirmasi/konfirmasi otomatis cek kelengkapan Barang menjadi tanggung jawab Pembeli secara pribadi.',
      },
      {
        title:
          'Buka Bangunan berwenang mengambil keputusan atas permasalahan-permasalahan transaksi yang belum terselesaikan akibat tidak adanya kesepakatan penyelesaian, baik antara Penyedia Produk dan Pembeli, dengan melihat bukti-bukti yang ada. Keputusan Buka Bangunan adalah keputusan akhir yang tidak dapat diganggu gugat dan mengikat pihak Penyedia Produk dan Pembeli untuk mematuhinya.',
      },
      {
        title:
          'Pengguna berhak mendapatkan Barang yang sesuai dan telah dibayar penuh oleh Pengguna, dan tidak dapat dikembalikan atau dibatalkan secara sepihak oleh Pengguna apabila Penyedia Produk telah menyediakan deskripsi Barang atau pembatalan sepihak tidak sesuai dengan ketentuan yang Buka Bangunan tetapkan.',
      },
      {
        title:
          'Pengguna berhak mendapatkan Barang yang telah dibayar penuh sepanjang Barang tersebut dicantumkan dengan harga yang benar dan tidak mengandung informasi yang salah termasuk tidak terbatas pada akibat kesalahan pengetikan maupun kesalahan sistem operasional Platform Buka Bangunan. Jika ada kesalahan informasi yang tercantum Platform Buka Bangunan, maka Pengguna menyetujui bahwa Buka Bangunan dapat melakukan penyesuaian/koreksi atas kesalahan informasi tersebut.',
      },
      {
        title:
          'Pengguna menyetujui bahwa jika ada kekeliruan atau kesalahan dalam informasi promo pada Platform Buka Bangunan, maka Buka Bangunan secara mutlak berhak untuk melakukan pembatalan transaksi pembelian Barang, ataupun tetap menindaklanjuti proses transaksi pembelian Barang yang dilakukan oleh Pengguna, dengan melakukan penyesuaian-penyesuaian/koreksi yang diperlukan terhadap kesalahan dalam informasi promo dimaksud.',
      },
      {
        title:
          'Jika satu dan lain hal atau karena alasan tertentu Buka Bangunan harus melakukan pengembalian dana/refund, maka Buka Bangunan akan segera menghubungi Pengguna untuk meminta konfirmasi dan data-data Pengguna yang diperlukan, untuk keperluan proses refund tersebut. Apabila dalam jangka waktu 14 (empat belas) hari kalender ternyata Pengguna tidak dapat dihubungi ataupun tidak memberikan respon kepada Buka Bangunan, maka Buka Bangunan tidak bertanggungjawab atas keterlambatan proses refund tersebut dan tidak dapat dimintakan pertanggungjawaban untuk membayar denda, pembayaran bunga dan sanksi lainnya sehubungan dengan keterlambatan proses refund tersebut dan/atau tidak dapat dimintakan pertanggungjawaban apabila ketiadaan respon tersebut mengakibatkan proses refund tidak dapat dilakukan.',
      },
      {
        title:
          'Terkait dengan pengembalian dana pembayaran, Buka Bangunan tidak memberikan jaminan apapun dalam akurasi waktu masuknya pengembalian dana ke rekening Pengguna. Proses pembayaran mungkin memerlukan waktu dan tunduk pada masing-masing bank dan/atau waktu dari proses internal penyedia sistem pembayaran.',
      },
    ],
  },
  {
    title: 'STATUS TRANSAKSI',
    slug: 'status-transaksi',
    description: [
      'Di bawah ini merupakan daftar status transaksi yang mungkin dialami Pembeli ketika melakukan transaksi di Platform Buka Bangunan:',
    ],
    list: [
      {
        title:
          'Jika Pembeli telah melakukan <i>check-out</i> pada halaman atur pesanan, maka status transaksi adalah <b>Sedang Disiapkan.</b>',
      },
      { title: 'Jika transaksi telah disetujui oleh Penyedia Produk, maka status transaksi adalah <b>Dikemas.</b>' },
      { title: 'Jika transaksi telah dikirim oleh Penyedia Produk, maka status transaksi adalah <b>Dikirim.</b>' },
      {
        title:
          'Jika Pembeli telah melakukan konfirmasi pada halaman cek kelengkapan barang dan telah membayar sesuai dengan metode pembayaran yang dipilih, maka status transaksi adalah <b>Barang diterima.</b>',
      },
      { title: 'Jika pembayaran telah diterima oleh Buka Bangunan, maka status transaksi adalah <b>Selesai.</b>' },
      {
        title:
          'Jika Pembeli menolak semua Barang pada halaman cek kelengkapan barang, maka status transaksi adalah <b>Dikembalikan.</b>',
      },
      {
        title:
          'Jika Penyedia Produk tidak dapat memenuhi pesanan yang diterima karena alasan tertentu, makan status transaksi adalah <b>Dibatalkan.</b>',
      },
    ],
  },
  {
    title: 'HARGA BARANG',
    slug: 'harga-barang',
    list: [
      {
        title:
          'Harga Barang yang terdapat dalam Platform Buka Bangunan adalah harga yang ditetapkan oleh Penyedia Produk. Pengguna dilarang memanipulasi harga barang dengan cara apapun.',
      },
      {
        title:
          'Pembeli memahami dan menyetujui bahwa kesalahan keterangan harga dan informasi lainnya yang disebabkan tidak terbaharuinya halaman Platform Buka Bangunan dikarenakan Android yang dipakai Pembeli adalah tanggung jawab Pembeli.',
      },
      {
        title:
          'Pembeli memahami dan menyetujui bahwa setiap masalah dan/atau perselisihan yang terjadi akibat ketidaksepahaman antara Penyedia Produk dan Pembeli tentang harga bukanlah merupakan tanggung jawab Buka Bangunan.',
      },
      {
        title:
          'Dengan melakukan pemesanan melalui Buka Bangunan, Pembeli menyetujui untuk membayar total biaya yang harus dibayarkan sebagaimana tertera dalam halaman pembayaran, yang terdiri dari harga barang, ongkos kirim, pajak dan biaya-biaya lain yang mungkin timbul dan akan diuraikan secara tegas dalam halaman pembayaran. Pembeli setuju untuk melakukan pembayaran melalui metode pembayaran yang telah dipilih sebelumnya oleh Pembeli.',
      },
      {
        title:
          'Pengguna mengetahui dan menyetujui bahwa harga yang tercantum pada Platform dapat mengalami perubahan secara sewaktu-waktu dan tanpa pemberitahuan terlebih dahulu.',
      },
      {
        title:
          'Aplikasi Buka Bangunan untuk saat ini hanya melayani transaksi jual beli Barang dalam mata uang Rupiah.',
      },
    ],
  },
  {
    title: 'PENGIRIMAN BARANG DAN TARIF',
    slug: 'pengiriman-barang-dan-tarif',
    list: [
      {
        title:
          'Pembeli diberikan kebebasan untuk memilih jam pengiriman pada halaman atur pesanan pada Platform Buka Bangunan. Jika Penyedia Produk tidak dapat memenuhi jam pengiriman yang telah diminta oleh Pembeli, maka Pembeli akan mendapatkan notifikasi pada whatsapp atas perubahan jam pengiriman. ',
      },
      { title: 'Pengiriman Barang dalam Platform Buka Bangunan merupakan tanggung jawab Penyedia Produk.' },
      {
        title:
          'Dalam hal diperlukan untuk dilakukan proses pengembalian Barang, maka Pembeli dapat tidak mencentang Produk Bahan Bangunan pada halaman cek kelengkapan produk pada Platform Buka Bangunan. ',
      },
      {
        title:
          'Pembeli memahami dan mengerti bahwa Buka Bangunan telah melakukan usaha sebaik mungkin dalam memberikan informasi tarif pengiriman kepada Pembeli berdasarkan lokasi secara akurat, namun Buka Bangunan tidak dapat menjamin keakuratan data tersebut dengan yang ada pada cabang setempat.',
      },
      { title: 'Biaya Pengiriman dapat berubah sewaktu-waktu tanpa pemberitahuan sebelumnya.' },
    ],
  },
  {
    title: 'PENGAKHIRAN',
    slug: 'pengakhiran',
    description: [
      'Buka Mitra berhak, tanpa pemberitahuan dan atas kebijakan Buka Mitra sendiri setiap saat, untuk mengakhiri, mengubah, menangguhkan atau menghentikan setiap bagian dari situs/Platform atau konten situs/Platform tanpa pemberitahuan terlebih dahulu. Buka Mitra dapat membatasi, menangguhkan, atau menghentikan akses Pengguna ke situs/Platform jika Buka Mitra menduga Pengguna melanggar syarat dan ketentuan ini dan/atau kebijakan lain yang sudah Buka Mitra tetapkan atau ketentuan hukum yang berlaku lainnya.',
    ],
  },
  {
    title: 'KONTAK BUKA BANGUNAN',
    slug: 'kontak-buka-bangunan',
    description: [
      'Pengguna dapat menghubungi Buka Bangunan terkait Syarat dan Ketentuan Buka Bangunan melalui whatsapp di nomor +6281211188771.',
    ],
  },
]
